import {Alert, Button, Col, message, Row, Space} from "antd";
import {useCreateStoreServiceContext} from "../../context/create-service";
import {StyledServiceButtonWrapper} from "../../../../../styles/onboarding/onboarding";
import {ServiceCoverImagesFormFields} from "../../../../../components/offering-form/services/cover-images";
import {FullPageLoader} from "../../../../../components/full-page-loader";
import {OfferingFormAccordionItem} from "../../../../../components/offering-form/accordion/accordion-item";
import {useNavigate} from "react-router-dom";
import {
  useStoreServiceCoverImagesDelete,
  useStoreServicePortfolioImagesDelete,
  useStoreServiceUploadCoverImages,
  useStoreServiceUploadPortfolioImages,
  useCoverImagesWithFallback,
  mapDomainToEmbedded,
} from "../../../../../features/media";
import {useGetStoreServicePortfolioImages} from "../../../../../react-query-hooks/store/services/upload-content";
import {useGetStoreServiceApi} from "../../../../../react-query-hooks/store/services/get-store-service";
import {ServicePortfolioImagesFormFields} from "../../../../../components/offering-form/services/portfolio-images";

export function CreateServiceCoverImagesUploadStep() {
  const storeServiceUploadCoverImagesMutation = useStoreServiceUploadCoverImages();
  const storeServiceCoverImagesDeleteMutation = useStoreServiceCoverImagesDelete();
  const storeServicePortfolioImagesDeleteMutation =
    useStoreServicePortfolioImagesDelete();
  const storeServiceUploadPortfolioImagesMutation =
    useStoreServiceUploadPortfolioImages();
  const {
    dispatch,
    state: {apiResponseData},
  } = useCreateStoreServiceContext();

  const getStoreServicePortfolioImages = useGetStoreServicePortfolioImages(
    apiResponseData?.productService.id
  );
  const navigate = useNavigate();

  const getStoreServiceApiQuery = useGetStoreServiceApi(
    apiResponseData?.productService.id
  );

  // v2 cover images fetch with embedded fallback
  const {coverImages, isLoading: isCoverImagesLoading} = useCoverImagesWithFallback({
    offeringType: "product-service",
    offeringId: getStoreServiceApiQuery.data?.productService?.id,
    embedded: getStoreServiceApiQuery.data?.productService?.cover_images,
  });
  const coverImagesForDisplay = mapDomainToEmbedded(coverImages);

  if (getStoreServiceApiQuery.isLoading || isCoverImagesLoading) {
    return <FullPageLoader />;
  }

  if (getStoreServiceApiQuery.isError) {
    return (
      <Alert
        message="Error"
        description={getStoreServiceApiQuery.error.message}
        type="error"
        showIcon
      />
    );
  }

  function handleCoverImagesItemDelete({
    mediaId,
    offeringId,
  }: {
    mediaId: string;
    offeringId: number;
  }) {
    storeServiceCoverImagesDeleteMutation.mutate(
      {mediaId, storeServiceId: offeringId},
      {
        onSuccess: () => {
          message.success("Deleted successfully");
        },
      }
    );
  }

  function handlePortfolioImagesItemDelete({
    mediaId,
    productServiceId,
  }: {
    mediaId: string;
    productServiceId: number;
  }) {
    storeServicePortfolioImagesDeleteMutation.mutate(
      {mediaId, storeServiceId: productServiceId},
      {
        onSuccess: () => {
          message.success("Deleted successfully");
        },
      }
    );
  }

  function handleNextStep() {
    dispatch({
      type: "update-create-service-form-step",
      payload: "automations",
    });
  }
  return (
    <div>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        <OfferingFormAccordionItem key={"Cover image"} index={0} title={"Cover image"}>
          <ServiceCoverImagesFormFields
            accordionIndex={0}
            serviceData={{
              id: getStoreServiceApiQuery.data.productService.id.toString(),
            }}
            defaultCoverImages={coverImagesForDisplay}
            deleteCoverImage={handleCoverImagesItemDelete}
            isDeleteLoading={storeServicePortfolioImagesDeleteMutation.isLoading}
            offeringId={getStoreServiceApiQuery.data.productService.id}
            isUploadLoading={storeServiceUploadCoverImagesMutation.isLoading}
            uploadCoverImages={storeServiceUploadCoverImagesMutation}
          />
        </OfferingFormAccordionItem>
        <OfferingFormAccordionItem
          key={"Portfolio images"}
          index={1}
          title={"Portfolio images"}
        >
          {getStoreServicePortfolioImages.isLoading ? (
            <>Loading....</>
          ) : getStoreServicePortfolioImages.isError ? (
            <>{getStoreServicePortfolioImages.error.message}</>
          ) : (
            <ServicePortfolioImagesFormFields
              accordionIndex={1}
              serviceData={{
                id: getStoreServiceApiQuery.data.productService.id.toString(),
              }}
              defaultPortfolioImages={getStoreServicePortfolioImages.data}
              deletePortfolioImage={handlePortfolioImagesItemDelete}
              isDeleteLoading={storeServiceCoverImagesDeleteMutation.isLoading}
              productServiceId={getStoreServiceApiQuery.data.productService.id}
              isUploadLoading={storeServiceUploadCoverImagesMutation.isLoading}
              uploadPortfolioImages={storeServiceUploadPortfolioImagesMutation}
            />
          )}
        </OfferingFormAccordionItem>
        <Row gutter={[0, 16]}>
          <Col span={24} sm={12}>
            <StyledServiceButtonWrapper>
              <Button
                onClick={() =>
                  dispatch({
                    type: "update-create-service-form-step",
                    payload: "basicForm",
                  })
                }
                block
                size="small"
                type="default"
              >
                Back
              </Button>
              <Button
                block
                type="primary"
                size="small"
                onClick={handleNextStep}
                disabled={
                  storeServiceUploadCoverImagesMutation.isLoading ||
                  storeServiceCoverImagesDeleteMutation.isLoading ||
                  storeServiceUploadPortfolioImagesMutation.isLoading ||
                  storeServicePortfolioImagesDeleteMutation.isLoading ||
                  coverImages.length < 1
                }
              >
                Next
              </Button>
            </StyledServiceButtonWrapper>
          </Col>
        </Row>
      </Space>
    </div>
  );
}
